import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

/**
 * Hook to handle periodic sync messages from service worker
 * Triggers data refresh when background sync occurs
 */
export function usePeriodicSyncHandler() {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'PERIODIC_SYNC') {
        console.log('Received periodic sync message from service worker');

        // Invalidate critical queries to trigger refetch
        queryClient.invalidateQueries({ queryKey: ['opportunities'] });
        queryClient.invalidateQueries({ queryKey: ['emails'] });
        queryClient.invalidateQueries({ queryKey: ['tasks'] });
        queryClient.invalidateQueries({ queryKey: ['contacts'] });

        // Show subtle toast
        toast.info('Data synced in background', {
          description: 'Your data has been updated',
          duration: 3000,
        });
      }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
    };
  }, [queryClient]);
}
